import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';

export class LoadComponentService extends BaseService {
  static async load(component) {
    try {
      // If component is already a component definition with a name, return it
      if (component?.name) {
        return component;
      }

      // If component has a default export, return it
      if (component?.default) {
        return component.default;
      }

      // If component is a promise or dynamic import, await it and return the default
      const componentPromise = component;
      const resolved = await componentPromise;
      return resolved?.default || resolved;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[LoadComponentService] Failed to load component:', e);
      return null;
    }
  }
}
